import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";

export const rejectedRequestsColumns = [
  {
    Header: "Date",
    accessor: "date",
    Cell: (props) => {
      return (
        <div>{moment(props?.row?.original?.date).format(displayDateFormat)}</div>
      );
    },
  },
  {
    Header: "Request For",
    accessor: "request_for",
    Cell: (props) => {
      const value = props?.row?.original;
      if (!value) {
        return "-";
      }
      return (
        <div className="py-4">
          <div className="font-size-small">{value?.head}</div>
          {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
            {value?.sub_head}
          </div> */}
        </div>
      );
    },
  },
  {
    Header: "Description",
    accessor: "description",
    Cell: (props) => {
      const value = props?.row?.original?.description;
      return value || "-";
    },
  },
  {
    Header: "Qty",
    accessor: "qty",
    Cell: (props) => {
      const value = props?.row?.original?.quantity;
      return value || "-";
    },
  },
  {
    Header: "Rate (₹)",
    accessor: "rate",
    Cell: (props) => {
      const value = props?.row?.original?.rate;
      return value || "-";
    },
  },
  {
    Header: "Total Amount (₹)",
    accessor: "amount",
    Cell: (props) => {
      const value = props?.row?.original?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => {
      return <div className="text-[var(--textRed)]">Rejected</div>;
    },
  },
];
